import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { Eye, BarChart2, QrCode } from "lucide-react";

const CampaignsTable = ({
  campaigns,
  visits,
  onShowLanding,
  onShowLog,
}) => {
  const getCampaignStats = (campaignId) => {
    const pageVisits = visits.filter(v => v.pageId === campaignId);
    return {
      transitions: pageVisits.length,
      clicks: pageVisits.filter(v => v.clickTarget).length,
      registrations: pageVisits.filter(v => v.targetReached).length,
    };
  };

  if (campaigns.length === 0) {
    return (
      <div className="text-center py-8 text-slate-400">
        Нет созданных кампаний. Создайте первую карту лояльности.
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Название / QR</TableHead>
            <TableHead className="text-right">Переходов</TableHead>
            <TableHead className="text-right">Кликов</TableHead>
            <TableHead className="text-right">Регистраций</TableHead>
            <TableHead>Дата</TableHead>
            <TableHead>Статус</TableHead>
            <TableHead className="text-center">Действия</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {campaigns.map((campaign) => {
            const stats = getCampaignStats(campaign.id);
            return (
              <TableRow key={campaign.id}>
                <TableCell>
                  <div className="font-medium">{campaign.name}</div>
                  <div className="text-xs font-mono text-slate-400">{campaign.shortUrl}</div>
                </TableCell>
                <TableCell className="text-right font-semibold">{stats.transitions}</TableCell>
                <TableCell className="text-right">{stats.clicks}</TableCell>
                <TableCell className="text-right text-emerald-600 font-medium">{stats.registrations}</TableCell>
                <TableCell className="text-slate-500 text-xs">{campaign.createdAt}</TableCell>
                <TableCell>
                  <Badge variant={campaign.status === 'active' ? 'default' : 'secondary'}>
                    {campaign.status === 'active' ? 'Активна' : 'Черновик'}
                  </Badge>
                </TableCell>
                <TableCell className="text-center">
                  <div className="flex justify-center gap-2">
                    <Button variant="ghost" size="icon" onClick={() => onShowLanding(campaign)} title="Просмотр страницы">
                      <Eye className="h-4 w-4" />
                    </Button>
                    <Button variant="ghost" size="icon" onClick={() => onShowLog(campaign.id)} title="Реестр визитов">
                      <BarChart2 className="h-4 w-4" />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => {
                        navigator.clipboard.writeText(campaign.shortUrl);
                        alert('Ссылка скопирована');
                      }}
                      title="Копировать QR-ссылку"
                    >
                      <QrCode className="h-4 w-4" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default CampaignsTable;